export const SET_TAXONOMY_GROUPS = 'SET_TAXONOMY_GROUPS';

const state = {
    entities: {}
};

const actions = {
    getTaxonomyGroups({ commit }) {
        axios.get(laroute.route('api.taxonomy-groups'))
            .then((response) => {
                commit(SET_TAXONOMY_GROUPS, {
                    entities: response.data.data
                });
            })
    },
};

const mutations = {
    [SET_TAXONOMY_GROUPS]: (state, payload) => {
        state.entities = Object.assign({}, state.entities, payload.entities);
    }
};

const getters = {
    taxonomyGroups: state => state.entities,
};

export default {
    // namespaced: true,
    getters,
    state,
    mutations,
    actions,
}
